module.exports = __webpack_public_path__ + "static/media/smart-n910.80de2961.png";